import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';
import AppTitle from '../../../layouts/AppTitle';
import { shopBg1 } from '../../../../assets/images';
import { useDispatch, useSelector } from 'react-redux';
import { getPageContent, productExtraAction } from '../../../../store/actions/ProductActions';
import _ from 'lodash';
import { endpoint } from '../../../../config/config';
import Slider from '@mui/material/Slider';
import { addItemToCart } from '../../../../store/actions/CartActions';
import { Link } from 'react-router-dom';
import AppLoader from '../../../pages/AppLoader';
import ProductCard from './ProductCard';

const Shop = () => {
  const dispatch = useDispatch();
  const myDivRef = useRef(null);

  const allProducts = useSelector(state => state?.products?.allProducts);
  const userShopFilters = useSelector(state => state?.products?.userShopFilters);
  const token = useSelector(state => state?.auth?.token);

  const [products, setProducts] = useState([]);
  const [catagories, setCatagories] = useState([]);
  const [defaultPriceRange, setDefaultPriceRange] = useState([]);

  useEffect(() => {
    dispatch(getPageContent('getAllProducts'));
    scrollToProducts();
  }, []);

  useEffect(() => {
    if (userShopFilters) {
      let filterProducts = [...allProducts];
      if (userShopFilters && userShopFilters?.category) {
        if (userShopFilters?.category == 'All') {
          filterProducts = [...allProducts];
        } else if (userShopFilters?.category) {
          filterProducts = allProducts?.filter(p => p.category == userShopFilters?.category);
        }
      }
      // if (userShopFilters?.priceRange) {
      //   if (userShopFilters?.priceRange?.min) {
      //     filterProducts = filterProducts?.filter(
      //       p => p?.price >= Number(userShopFilters?.priceRange?.min)
      //     );
      //   }
      //   if (userShopFilters?.priceRange?.max) {
      //     filterProducts = filterProducts?.filter(
      //       p => p?.price <= userShopFilters?.priceRange?.max
      //     );
      //   }
      // }

      if (userShopFilters?.search) {
        filterProducts = filterProducts?.filter(p =>
          p?.title?.toLowerCase()?.includes(userShopFilters?.search?.toLowerCase())
        );
      }

      // const nonPricingCompounds = allProducts?.filter(a => a.isMultiplePrices);
      // filterProducts = [...filterProducts, ...nonPricingCompounds];

      // filterProducts = _.uniqBy(filterProducts, '_id');

      setProducts(filterProducts);
    }
  }, [userShopFilters]);

  useEffect(() => {
    if (allProducts && !userShopFilters?.category) {
      setProducts(allProducts);
    }

    if (allProducts) {
      let uniqCatagories = _.uniqBy(allProducts, 'category')
        ?.map(p => p.category)
        ?.sort();
      setCatagories(['All', ...uniqCatagories]);
      if (!userShopFilters) {
        defaultShopFilters();
      }
    }
  }, [allProducts]);

  function scrollToProducts() {
    if (myDivRef.current) {
      myDivRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }

  function defaultShopFilters() {
    const sortByPrice = _.sortBy(allProducts, 'price');
    dispatch(
      productExtraAction('userShopFilters', {
        category: 'All',
        search: '',
        // priceRange: { min: sortByPrice?.[0]?.price, max: sortByPrice?.at(-1)?.price },
        defaultPriceRange: { min: sortByPrice?.[0]?.price, max: sortByPrice?.at(-1)?.price },
      })
    );
  }

  const handleCategoryFilter = category => {
    const prevShopFilters = userShopFilters ?? {};
    dispatch(productExtraAction('userShopFilters', { ...prevShopFilters, search: '', category }));
    scrollToProducts();
  };

  const handlePriceChange = (e, newValue) => {
    const priceRange = {
      min: newValue?.[0],
      max: newValue?.[1],
    };
    const prevShopFilters = userShopFilters ?? {};
    dispatch(productExtraAction('userShopFilters', { ...prevShopFilters, priceRange }));
  };

  const handleProductSearch = e => {
    const prevShopFilters = userShopFilters ?? {};
    dispatch(
      productExtraAction('userShopFilters', {
        ...prevShopFilters,
        category: 'All',
        search: e?.target?.value,
      })
    );
  };

  return allProducts ? (
    <div>
      <Helmet>
        <title>Shop Custom Cakes & Desserts Online – SayCheeze Cakes</title>
        <meta
          name='description'
          content='Browse and shop a wide range of custom cakes, cheesecakes, desserts, and baked goodies from SayCheeze Cakes in Bangalore. Filter by category and find your perfect treat.'
        />
        <link rel='canonical' href='https://www.saycheezecakes.com/shop' />
      </Helmet>

      <AppTitle bgImg={shopBg1} title={'Shop'} from={'Home'} to='Shop' link={'/'} />

      <div className='shop-product-section sidebar-left overflow-hidden'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-4'>
              <div className='sidebars'>
                <div className='sidebars_inner'>
                  <div className='sidebars_search'>
                    <input
                      type='text'
                      value={userShopFilters?.search}
                      placeholder='Search here...'
                      className='sidebars_search__input'
                      onChange={handleProductSearch}
                    />
                    <span disabled className='sidebars_search__btn'>
                      <i className='lastudioicon-zoom-1'></i>
                    </span>
                  </div>

                  <div className='sidebars_widget'>
                    <h3 className='sidebars_widget__title'>Category</h3>
                    <ul className='sidebars_widget__category'>
                      {catagories?.map((category, i) => (
                        <li onClick={() => handleCategoryFilter(category)} key={i}>
                          <a
                            // href='#'
                            className={category === userShopFilters?.category && 'text-primary'}
                          >
                            {category}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* <div className='sidebars_widget'>
                    <h3 className='sidebars_widget__title'>Price Filter</h3>
                    <div className='range-slider'>
                      <Slider
                        getAriaLabel={() => 'Price range'}
                        value={[userShopFilters?.priceRange?.min, userShopFilters?.priceRange?.max]}
                        onChange={handlePriceChange}
                        valueLabelDisplay='auto'
                        max={userShopFilters?.defaultPriceRange?.max}
                        min={userShopFilters?.defaultPriceRange?.min}
                        sx={{
                          color: 'black',
                          '& .MuiSlider-thumb': {
                            backgroundColor: '#212121',
                          },
                          '& .MuiSlider-track': {
                            backgroundColor: '#212121',
                          },
                          '& .MuiSlider-rail': {
                            backgroundColor: 'lightgray',
                          },
                        }}
                      />
                    </div>
                    <div className='extra-controls'>
                      <button className='extra-controls_btn' onClick={defaultShopFilters}>
                        Clear
                      </button>
                      <div className='extra-controls_filter'>
                        <label>Price: </label>
                        <input
                          type='text'
                          className='js-input-from'
                          value={userShopFilters?.priceRange?.min}
                        />{' '}
                        -{' '}
                        <input
                          type='text'
                          className='js-input-to'
                          value={userShopFilters?.priceRange?.max}
                        />
                      </div>
                    </div>
                  </div> */}

                  <div className='sidebars_widget d-none d-md-block'>
                    <h3 className='sidebars_widget__title'>Popular products</h3>
                    <ul className='sidebars_widget__product'>
                      {allProducts
                        ?.filter(p => p.isRecommended)
                        ?.map((product, i) => (
                          <li className='single-product' key={i}>
                            <Link to={`/product/${product?._id}`} className='single-product_thumb'>
                              <img
                                src={`${product?.files?.[0]?.path}`}
                                alt='Sidebar-Image'
                                loading='lazy'
                              />
                            </Link>
                            <div className='single-product_content'>
                              <Link
                                to={`/product/${product?._id}`}
                                className='single-product_content__title'
                              >
                                {product?.title}
                              </Link>
                              <span className='single-product_content__price'>
                                ₹
                                {product?.price > 0
                                  ? product?.price
                                  : product?.priceOptions?.[0]?.price ?? ''}
                              </span>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>

                  {/* <div className='sidebars_widget'>
                    <h3 className='sidebars_widget__title'>Tags</h3>
                    <ul className='sidebars_widget__tags'>
                      <li>
                        <a href='shop.html'>Cake, </a>
                      </li>
                      <li>
                        <a href='shop.html'>Cupcake, </a>
                      </li>
                      <li>
                        <a href='shop.html'>Donut, </a>
                      </li>
                      <li>
                        <a href='shop.html'>Muffin, </a>
                      </li>
                      <li>
                        <a href='shop.html'>New, </a>
                      </li>
                      <li>
                        <a href='shop.html'>Waffle</a>
                      </li>
                    </ul>
                  </div> */}

                  {allProducts?.[0] && (
                    <div className='sidebars_widget d-none d-lg-block'>
                      <Link
                        to={`/product/${allProducts?.[0]?._id}`}
                        className='sidebars_widget__banner'
                      >
                        <img
                          src={`${allProducts?.[0]?.files?.[0]?.path}`}
                          alt='banner-Image'
                          loading='lazy'
                        />

                        <div className='banner-content'>
                          <span className='banner-content_title'>Check it now</span>
                        </div>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className='col-md-8 section-padding-04' ref={myDivRef}>
              <div className='shop-topbar'>
                <div className='shop-topbar-item shop-topbar-left'>
                  <p>All Products</p>
                  {/* <p>Showing 1 - 12 of 25 result</p> */}
                </div>

                <div className='shop-topbar-right'>
                  <div className='shop-topbar-item'>
                    {/* <select name='SortBy' id='SortBy'>
                      <option value='manual'>Sort by Rated</option>
                      <option value='best-selling'>Sort by Latest</option>
                      <option value='price-ascending'>Price ↑</option>
                      <option value='price-descending'>Price ↓</option>
                    </select> */}
                  </div>

                  {/* <div className='shop-topbar-item'>
                    <select name='paginateBy' id='paginateBy'>
                      <option value='3'>Show 3</option>
                      <option value='4'>Show 4</option>
                      <option value='5'>Show 5</option>
                      <option value='6'>Show 6</option>
                      <option value='7'>Show 7</option>
                    </select>
                  </div> */}
                </div>
              </div>
              <div className='row row-cols-xl-3 row-cols-lg-2 row-cols-sm-2 row-cols-1 mb-n50'>
                {_.sortBy(products, 'title')
                  ?.filter(f => !f.isBlocked)
                  ?.map((product, i) => (
                    <ProductCard product={product} key={i} />
                  ))}
              </div>
              {/* <div className='shop-bottombar'>
                <ul className='pagination'>
                  <li className='disabled'>
                    <a href='#prev'>←</a>
                  </li>
                  <li>
                    <a className='active' href='#page=1'>
                      1
                    </a>
                  </li>
                  <li>
                    <a href='#page=2'>2</a>
                  </li>
                  <li>
                    <a href='#page=3'>3</a>
                  </li>
                  <li>
                    <a href='#page=4'>4</a>
                  </li>
                  <li>
                    <a href='#page=5'>5</a>
                  </li>
                  <li>
                    <a href='#next'>→</a>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <AppLoader />
  );
};

export default Shop;
